import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import "@/MiniApp.css";
import MiniApp from "./MiniApp";

const API = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/api`;
const BOT = "https://t.me/verkeerscontrole_bot";

const icons = {
  radar: <><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2"/></>,
  download: <><path d="M12 3v12m-5-5 5 5 5-5M4 17v4h16v-4"/></>,
  car: <><path d="m5 8 2-5h10l2 5M4 8h16v11H4ZM6 19v2m12-2v2M7 12h.01M17 12h.01"/></>,
  road: <><path d="m3 21 5-18m8 0 5 18M12 3v4m0 4v3m0 4v3"/></>,
  apple: <path fill="currentColor" stroke="none" d="M16.7 2c.2 1.4-.5 2.7-1.3 3.5-.9.9-2 1.5-3.3 1.4-.2-1.3.5-2.7 1.3-3.5.9-.9 2.2-1.5 3.3-1.4ZM20 17.3c-.5 1.2-.8 1.7-1.5 2.7-.9 1.4-2.1 3-3.7 3-1.4 0-1.8-.9-3.6-.9-1.7 0-2.2.9-3.6.9-1.5 0-2.6-1.5-3.5-2.9C1.6 16.4 1 11.5 2.6 9c1.2-1.8 3-2.8 4.8-2.8 1.5 0 2.5.9 3.7.9 1.1 0 2.9-1.1 4.8-.9 1.6.1 2.9.9 3.8 2.2-3.5 1.9-3 7 .3 8.9Z"/>,
  android: <><path d="m7 4-2-3m12 3 2-3M4 11a8 8 0 0 1 16 0ZM4 14v5h16v-5M8 19v3m8-3v3M1 12v6m22-6v6"/><path d="M8 7h.01M16 7h.01"/></>,
  map: <><path d="m3 6 5-2 8 3 5-2v13l-5 2-8-3-5 2Z"/><path d="M8 4v13M16 7v13"/></>,
  route: <><path d="M5 19 19 5M8 5h11v11"/><circle cx="5" cy="19" r="2"/></>,
  shield: <><path d="M12 3 20 6v6c0 5-3.4 8-8 9-4.6-1-8-4-8-9V6Z"/><path d="m9 12 2 2 4-5"/></>,
  camera: <><rect x="3" y="7" width="18" height="12" rx="3"/><circle cx="12" cy="13" r="3"/><path d="m8 7 1.5-3h5L16 7"/></>,
  users: <><circle cx="9" cy="7" r="4"/><path d="M2 21v-2a5 5 0 0 1 10 0v2M16 3.5a4 4 0 0 1 0 7M15 15a5 5 0 0 1 7 4.5V21"/></>,
  groups: <><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2 20v-2a5 5 0 0 1 10 0v2M14 16a4 4 0 0 1 8 2v2"/></>,
  telegram: <><path d="m21 3-7.5 18-4.2-7.2L3 10.5Z"/><path d="m9.3 13.8 5.8-5"/></>,
  alert: <><path d="M12 3 2.8 20h18.4Z"/><path d="M12 9v5M12 17h.01"/></>,
};

function Icon({ name, size = 23 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{icons[name] || icons.radar}</svg>;
}

function Logo() {
  return <a className="brand" href="#top"><span><Icon name="radar"/></span>MeldRadar</a>;
}

function Phone() {
  return <div className="phone" role="img" aria-label="Voorbeeld van MeldRadar rond Amsterdam-Noord">
    <i className="notch"/><div className="phone-screen">
      <img src="/meldradar-kaart.jpeg" alt="De kaart van MeldRadar met actuele meldingen rond Amsterdam"/>
    </div>
  </div>;
}

function LiveStats() {
  const [stats, setStats] = useState({});
  const [online, setOnline] = useState(false);
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const response = await fetch(`${API}/stats`);
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (mounted) { setStats(data); setOnline(true); }
      } catch (_) { if (mounted) setOnline(false); }
    };
    load(); const timer = setInterval(load, 30000);
    return () => { mounted = false; clearInterval(timer); };
  }, []);
  const n = value => value == null ? "—" : new Intl.NumberFormat("nl-NL").format(value);
  const data = [[stats.active_meldingen, "actief"], [stats.total_meldingen, "meldingen"], [stats.total_users, "melders"], [stats.subscribed_groups, "groepen"]];
  return <section className="livebar" aria-label="Actuele totalen" id="live">
    <div className={`live-status ${online ? "online" : ""}`} role="status"><i/>{online ? "Live" : "Even geen live data"}</div>
    {data.map(([value, label]) => <div className="metric" key={label}><b>{n(value)}</b><small>{label}</small></div>)}
  </section>;
}

// Set these build variables when the public store listings are available.
const STORES = [
  { name: "App Store", icon: "apple", url: process.env.REACT_APP_IOS_DOWNLOAD_URL },
  { name: "Google Play", icon: "android", url: process.env.REACT_APP_ANDROID_DOWNLOAD_URL },
];
function Downloads() {
  return <section className="downloads" id="download"><div className="shell split">
    <div><span className="eyebrow">DOWNLOAD</span><h2>Altijd bij de hand.</h2><p>Voor iOS en Android. Meldingen afgestemd op jouw route en regio.</p></div>
    <div className="store-links">{STORES.map(({ name, icon, url }) => {
      const content = <><Icon name={icon} size={27}/><span><small>{url ? "Download via" : "Binnenkort in de"}</small><b>{name}</b></span></>;
      return url ? <a className="store-badge" href={url} key={name} target="_blank" rel="noreferrer">{content}</a> : <div className="store-badge unavailable" key={name} aria-label={`${name}: binnenkort beschikbaar`}>{content}</div>;
    })}</div>
  </div></section>;
}

function Partners() {
  return <section className="partners" id="partners"><div className="shell split"><div><span className="eyebrow">SAMENWERKEN</span><h2>Samen maken we verkeersinformatie sterker.</h2><p>In de toekomst werken we samen met data- en mobiliteitspartners.</p></div><div><div className="partner-list">{[1,2,3,4].map(i => <span key={i}>Partner binnenkort</span>)}</div><a className="text-link" href="mailto:info@meldradar.nl?subject=Partner%20worden">Partner worden →</a></div></div></section>;
}

function Landing() {
  return <div className="landing" id="top">
    <a className="skip-link" href="#main">Naar inhoud</a>
    <header><div className="shell nav"><Logo/><nav aria-label="Hoofdnavigatie"><a href="#werking">Hoe het werkt</a><a href="#telegram">Telegram</a><a href="#partners">Partners</a></nav><a className="nav-download" href="#download"><Icon name="download" size={20}/>Download</a></div></header>
    <main id="main">
      <section className="hero"><div className="shell hero-inner"><div className="hero-copy"><span className="eyebrow">REAL-TIME OP DE HOOGTE</span><h1>Weet wat er speelt.<br/><em>Nog vóór je er bent.</em></h1><p>Actuele meldingen over controles, files, wegwerkzaamheden en incidenten.</p><a className="btn" href="#download"><Icon name="download" size={20}/>Download MeldRadar</a><div className="platforms"><span><Icon name="apple" size={20}/>iOS</span><span><Icon name="android" size={20}/>Android</span></div></div><div className="phone-wrap"><Phone/></div></div><div className="shell"><LiveStats/></div></section>
      <section className="features" id="werking"><div className="shell"><span className="eyebrow">ONDERWEG</span><h2>Alleen wat relevant is.</h2><div className="feature-list">
        <article><Icon name="camera" size={32}/><div><h3>Controles</h3><p>Gemeld en bevestigd door weggebruikers.</p></div></article>
        <article><Icon name="car" size={32}/><div><h3>Files</h3><p>Vertraging zichtbaar voordat je erin rijdt.</p></div></article>
        <article><Icon name="road" size={32}/><div><h3>Wegwerk &amp; incidenten</h3><p>Direct context bij hinder en gevaar.</p></div></article>
      </div></div></section>
      <section className="telegram" id="telegram"><div className="shell split"><div><span className="eyebrow">TELEGRAM</span><h2>MeldRadar werkt ook gewoon in Telegram.</h2><p>Ontvang actuele meldingen via de bot, persoonlijk of samen in een groep.</p><div className="telegram-actions"><a className="btn" href={BOT} target="_blank" rel="noreferrer"><Icon name="telegram" size={18}/>Start de bot</a><a className="text-link" href={`${BOT}?startgroup=true`} target="_blank" rel="noreferrer">Toevoegen aan een groep →</a></div></div><div className="chat" aria-label="Voorbeeld van een Telegram-melding"><div className="chat-head"><i><Icon name="telegram"/></i><div><b>MeldRadar</b><small>bot · voorbeeld</small></div></div><div className="bubble"><Icon name="camera" size={22}/><div><b>Snelheid · Molenaarsweg</b><p>Amsterdam-Noord · 3,2 km</p></div><time>14:27</time></div></div></div></section>
      <Downloads/><Partners/>
    </main>
    <footer><div className="shell"><Logo/><span>Samen onderweg slimmer.</span><nav aria-label="Footernavigatie"><a href="mailto:info@meldradar.nl">Contact</a><a href={BOT} target="_blank" rel="noreferrer">Telegram</a></nav><small>© {new Date().getFullYear()} MeldRadar</small></div></footer>
  </div>;
}

function AppRouter() {
  // telegram-web-app.js bestaat ook in een gewone browser en maakt daar een
  // leeg initDataUnsafe-object aan. Dat object is truthy, waardoor de publieke
  // site ten onrechte altijd de Mini App liet zien. Alleen ondertekende,
  // niet-lege initData bewijst dat de pagina echt vanuit Telegram is geopend.
  const telegramInitData = window.Telegram?.WebApp?.initData;
  const inTelegram = typeof telegramInitData === "string" && telegramInitData.length > 0;
  return <BrowserRouter><Routes><Route path="/" element={inTelegram ? <MiniApp/> : <Landing/>}/><Route path="/miniapp" element={<MiniApp/>}/></Routes></BrowserRouter>;
}

export default AppRouter;
